export default __webpack_public_path__ + "static/logo-fa23fe6578f4d6ddb95f9f742e42551d.png";